export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./template.vue?vue&type=template&id=200984d8&"


//////////////////
// WEBPACK FOOTER
// ./src/views/template.vue?vue&type=template&id=200984d8&
// module id = 109
// module chunks = 16